import { Component } from 'react';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';
import { sendLog } from '../../services/logsService';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  async componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });

    try {
      await sendLog({
        message: `${error.name} - ${error.message}`,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
        component: 'ErrorBoundary',
        props: this.props.logProps ? JSON.stringify(this.props) : undefined,
        url: window.location.href,
        userAgent: navigator.userAgent
      });
    } catch (logError) {
      console.error('Failed to log error:', logError);
    }
  }

  handleRetry = () => {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-slate-50">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8 max-w-md w-full">
            <div className="flex flex-col items-center text-center">
              <div className="p-4 bg-red-100 rounded-full mb-6">
                <FaExclamationTriangle className="text-red-600 text-4xl" />
              </div>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3 tracking-tight">
                Algo deu errado
              </h2>
              <p className="text-base text-slate-600 mb-8 leading-6">
                Ocorreu um erro inesperado. Você pode tentar recarregar a página.
              </p>
              <button
                onClick={this.handleRetry}
                className="bg-slate-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-slate-800 focus:ring-2 focus:ring-slate-700/20 transition-all duration-200 flex items-center gap-2"
              >
                <FaRedo className="text-sm" /> 
                Tentar Novamente
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;